import React, { useEffect, useContext, useState, Fragment } from 'react';
import Input from '../components/bronson/Input';
import Button from '../components/bronson/Button';
import Traductor from '../components/Traductor';
import { UserContext } from '../contexts/UserContext';
import UserService from '../services/UserService';
import { withCookies } from 'react-cookie';
import RadioButton from '../components/bronson/RadioButton';
import ToastNotification from '../components/bronson/ToastNotification';
import PopupAlertLegalPersonalData from '../components/PopupAlertLegalPersonalData';
import Globals from '../Globals';
import Loading from '../components/bronson/Loading';

//CSS
import '../components/css/profile.css';

function UserModule({ cookies }) {
    const t = new Traductor();
    const { user, setUser } = useContext(UserContext);
    const [userForm, setUserForm] = useState({});
    const [ReadAlertLegal, SetReadAlertLegal] = useState(false);
    const [IsOpenLegalAlert, SetIsOpenLegalAlert] = useState(false);
    const [errors, setErrors] = useState({
        NameUserError: '',
        FirstSurnameError: '',
    });
    const [showToast, setShowToast] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        FillData();
    }, [user.data]);

    const FillData = () => {
        setUserForm(user.data);
    };

    const onChange = (e, name) => {
        PutEmptyErrors(name, e.target.value);
        setUserForm({ ...userForm, [name]: e.target.value });
    };

    const onSubmit = () => {
        if (validate()) {
            if (ReadAlertLegal) {
                setLoading(true);
                userForm.WorkerId = userForm.Empleado.Id;
                let response = SaveDatauser(userForm);
            } else {
                alert('debe aceptar las condiciones legales ! ');
            }
        }
    };

    async function SaveDatauser(userForm) {
        let InsertDatauserResponse = await new UserService().SaveDataUser(
            cookies.get(Globals.COOKIES.JWT).AccessToken,
            userForm
        );
        if ((InsertDatauserResponse.Result = 'true')) {
            setUser(userForm);
            setShowToast({
                title: '¡Guardado!',
                text: 'Tus datos personales han sido actualizados',
                type: 'success',
                closeText: 'Cerrar notificación',
                timeout: true,
            });
        } else {
            setShowToast({
                title: '¡Error!',
                text: 'No se han podido actualizar tus datos',
                type: 'error',
                closeText: 'Cerrar notificación',
                timeout: true,
            });
        }
        setLoading(false);
    }

    function PutEmptyErrors(name, value) {
        if (name == 'Surname' && value != '') {
            errors.FirstSurnameError = '';
        }
        if (name == 'Name' && value != '') {
            errors.NameUserError = '';
        }
    }

    const validate = () => {
        let isValid = true;
        let errorss = {};
        if (userForm.Name != '') {
            errorss.NameUserError = '';
        } else {
            errorss.NameUserError = 'Debe introducir su nombre';
            isValid = false;
        }

        if (userForm.Surname != '') {
            errorss.FirstSurnameError = '';
        } else {
            errorss.FirstSurnameError = 'Debe introducir su primer apellido';
            isValid = false;
        }
        setErrors(errorss);
        return isValid;
    };

    let optionsInputNIF = {
        id: 'my-profile-user-nif',
        name: 'DocumentId',
        disabled: true,
        type: 'text',
        label: t.getTraduction('DocumentType'),
        event: true,
        customAttributes: {
            context: 'documentId',
        },
    };

    let optionsInputNombre = {
        id: 'my-profile-user-name',
        name: 'Name',
        type: 'text',
        label: t.getTraduction('Name'),
        event: true,
        isRequired: true,
        className: errors.NameUserError ? 'is-error' : '',
        customAttributes: {
            context: 'name',
        },
    };

    let optionsInputApellido = {
        id: 'my-profile-user-surname',
        name: 'Surname',
        type: 'text',
        label: t.getTraduction('Surname'),
        event: true,
        isRequired: true,
        className: errors.FirstSurnameError ? 'is-error' : '',
        customAttributes: {
            context: 'surname',
        },
    };

    let optionsInputSegundoApellido = {
        id: 'my-profile-user-surname2',
        name: 'Surname2',
        type: 'text',
        label: t.getTraduction('Surname2'),
        event: true,
        customAttributes: {
            context: 'surname2',
        },
    };

    let optionsInputEmail = {
        id: 'my-profile-user-email',
        name: 'Email',
        type: 'text',
        disabled: true,
        label: t.getTraduction('Email'),
        event: true,
        customAttributes: {
            context: 'email',
        },
    };

    let optionsInputPhone = {
        id: 'my-profile-user-phone',
        name: 'Phone',
        type: 'number',
        label: t.getTraduction('Phone'),
        event: true,
        customAttributes: {
            context: 'phone',
        },
    };

    const RadioLegalAlert = {
        id: 'legalAlert',
        name: '',
        className: '',
        text: '',
        showLabel: false,
        values: [
            { text: t.getTraduction('YesSeeLegalAlert'), value: 'Si' },
            { text: t.getTraduction('NoSeeLegalAlert'), value: 'No' },
        ],
    };

    const SetReaLegalAlert = value => {
        if (value == 'No') {
            SetReadAlertLegal(false);
        } else {
            SetReadAlertLegal(true);
        }
    };

    const CloseModalAlert = value => {
        SetIsOpenLegalAlert(false);
    };

    const OpenModalAlert = value => {
        SetIsOpenLegalAlert(true);
    };

    const OpenPopupLegalAlert = () => {
        if (!IsOpenLegalAlert) return null;
        return (
            <PopupAlertLegalPersonalData
                CloseModalAlert={CloseModalAlert}
            ></PopupAlertLegalPersonalData>
        );
    };

    const printSaveButton = () => {
        let disabled = true;
        if (
            ReadAlertLegal &&
            errors.NameUserError == '' &&
            errors.FirstSurnameError == ''
        )
            disabled = false;

        let optionsBtn = {
            text: t.getTraduction('BtnGuardar'),
            value: 'guardar',
            class: '',
            disabled,
        };

        return <Button options={optionsBtn} onClick={onSubmit}></Button>;
    };

    const printToastNotification = () => {
        if (Object.keys(showToast).length == 0) return null;
        return (
            <ToastNotification
                options={showToast}
                closeToast={() => setShowToast({})}
            />
        );
    };

    return (
        <Fragment>
            <div className="c-tabs__content  js-tabs__content u-mb-xlarge">
                <fieldset className="o-fieldset">
                    <legend className="c-form-heading  ">
                        <strong className="c-form-heading__title u-mt">
                            {t.getTraduction('PersonalData')}
                        </strong>
                        <small className="c-form-heading__text u-mb">
                            {t.getTraduction('AccountText')}
                        </small>
                    </legend>
                    <div className="o-fieldset__row">
                        <div className="o-layout">
                            <div className="o-layout__item u-1/4 u-1/2@m u-1/1@s">
                                <Input
                                    options={optionsInputNIF}
                                    onChange={e =>
                                        onChange(e, optionsInputNIF.name)
                                    }
                                    value={userForm.DocumentId}
                                ></Input>
                            </div>
                            <div className="o-layout__item  u-1/4 u-1/2@m u-1/1@s">
                                <Input
                                    options={optionsInputNombre}
                                    onChange={e =>
                                        onChange(e, optionsInputNombre.name)
                                    }
                                    value={userForm.Name}
                                ></Input>
                                <p
                                    className="c-error-message"
                                    id="NameUserErro"
                                >
                                    {errors.NameUserError}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="o-fieldset__row">
                        <div className="o-layout">
                            <div className="o-layout__item u-1/4 u-1/2@m u-1/1@s">
                                <Input
                                    options={optionsInputApellido}
                                    onChange={e =>
                                        onChange(e, optionsInputApellido.name)
                                    }
                                    value={userForm.Surname}
                                ></Input>
                                <p
                                    className="c-error-message"
                                    id="FirstSurnameError"
                                >
                                    {errors.FirstSurnameError}
                                </p>
                            </div>

                            <div className="o-layout__item u-1/4 u-1/2@m u-1/1@s">
                                <Input
                                    options={optionsInputSegundoApellido}
                                    onChange={e =>
                                        onChange(
                                            e,
                                            optionsInputSegundoApellido.name
                                        )
                                    }
                                    value={userForm.Surname2}
                                ></Input>
                            </div>
                        </div>
                    </div>
                    <div className="o-fieldset__row">
                        <div className="o-layout">
                            <div className="o-layout__item u-1/4 u-1/2@m u-1/1@s">
                                <Input
                                    options={optionsInputEmail}
                                    onChange={e =>
                                        onChange(e, optionsInputEmail.name)
                                    }
                                    value={userForm.Email}
                                ></Input>
                            </div>
                            <div className="o-layout__item u-1/4 u-1/2@m u-1/1@s">
                                <Input
                                    options={optionsInputPhone}
                                    onChange={e =>
                                        onChange(e, optionsInputPhone.name)
                                    }
                                    value={userForm.Phone}
                                ></Input>
                            </div>
                        </div>
                    </div>
                    <div className="o-fieldset__row u-mt">
                        <div className="o-layout">
                            <div className="o-layout__item u-1/2 u-1/1@s">
                                <p className="u-mt">
                                    {t.getTraduction('InitLegalAlertLabel')}
                                    <a
                                        onClick={OpenModalAlert}
                                        style={{ textDecoration: 'underline' }}
                                    >
                                        {t.getTraduction('LegalAlertLabel')}
                                    </a>
                                </p>
                                <RadioButton
                                    value={ReadAlertLegal ? 'Si' : 'No'}
                                    options={RadioLegalAlert}
                                    onChange={SetReaLegalAlert}
                                ></RadioButton>
                            </div>
                        </div>
                    </div>

                    {OpenPopupLegalAlert()}

                    <div className="o-fieldset__row">
                        <div className="o-layout">
                            <div className="o-layout__item  u-1/3 u-1/2@m u-1/1@s">
                                {printSaveButton()}
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            {printToastNotification()}
            <Loading ariaBusy={loading}></Loading>
        </Fragment>
    );
}
export default withCookies(UserModule);
